import axios from "axios";
import { ref } from "vue";
import { HubConnectionBuilder, LogLevel } from "@microsoft/signalr";
import router from "../routes";
import { ElMessage } from "element-plus";

axios.defaults.withCredentials = true; // 允许跨域携带cookie
axios.defaults.headers.post['Content-Type'] = 'application/json';
const instance = axios.create({
    baseURL: "https://api.sunsensitive.cn",
}); // 创建带jwttoken的axios实例
const refreshinstance = axios.create({
    baseURL: "https://api.sunsensitive.cn",
}); // 创建带refreshtoken的axios实例

const connection = new HubConnectionBuilder()
    .withUrl("https://api.sunsensitive.cn/messageHub")
    .configureLogging(LogLevel.Information) // 配置日志级别
    .withAutomaticReconnect() // 启用自动重连 
    .build();

// 请求拦截器
instance.interceptors.request.use((config) => {
    // 在发送请求之前做些什么
    if (localStorage.getItem("jwtToken")) {
        config.headers['Authorization'] = "Bearer " + localStorage.getItem("jwtToken");
    }
    return config;
}, (error) => {
    // 对请求错误做些什么
    return Promise.reject(error);
});
// 获取token请求拦截器
instance.interceptors.response.use((response) => {
    // 对响应数据做点什么
    return response;
}, async (error) => {
    // 处理错误
    const originalRequest = error.config;
    if (error.response && error.response.status === 401 && !originalRequest._retry) {
        // 准备刷新token
        const res = await refreshtoken();
        localStorage.setItem("jwtToken", res.jwttoken);
        originalRequest.headers['Authorization'] = `Bearer ${res.jwttoken}`;
        originalRequest._retry = true; // 避免无限循环
        return await instance.request(originalRequest);

    } else {
        if (error.response && error.response.status === 403) {
            ElMessage.warning("没有访问权限。");
        }
        return Promise.reject(error);
    }
});

// 刷新token请求拦截器
refreshinstance.interceptors.request.use((config) => {
    // 在发送请求之前做些什么
    if (localStorage.getItem("refreshToken")) {
        config.headers['Authorization'] = "Bearer " + localStorage.getItem("refreshToken");
    } else {
        router.push({ name: 'Login', query: { sourceurl: router.currentRoute.value.fullPath } });
    }
    return config;
}, (error) => {
    // 对请求错误做些什么
    return Promise.reject(error);
}
);

export const getVersion2=(): Promise<{result: boolean, version: string }> => {
    return new Promise((resolve, reject) => {
        instance({
            method: "get",
            url: "/ClientAuthorLogin/GetVersion2",
        }).then((response) => {
            if (response.status === 200 && response.data.result === true) { // 成功
                resolve({ result: response.data.result, version: response.data.version })
            }   else { // 失败
                reject('')
            }       
        }).catch((err) => {
            reject('')
        })
    })
}
// 获取随机图片
export const getRandomImage = (scene: string): Promise<{ base64Image: string, scenecode: string, error: string }> => {
    return new Promise((resolve, reject) => {
        instance({
            method: "get",
            url: "/LoginNRegist/GetVerifiImage",
            params: { scenecode: scene },
        }).then((response) => {
            if (response.status === 200 && response.data.result === true) { // 成功
                resolve({ base64Image: response.data.Data.Base64Image, scenecode: response.data.Data.SceneCode, error: "" })
            } else { // 失败
                reject({ base64Image: "", scenecode: scene, error: response.statusText || "获取图片失败" })
            }
        }).catch((err) => {
            reject({ base64Image: "", scenecode: scene, error: err.message || "网络错误" })
        })
    })
}

// 发送短信
export const sendSms = (scene: string, phonenumber: string): Promise<{ result: boolean, scenecode: string, msg: string }> => {
    return new Promise((resolve, reject) => {
        instance({
            method: "post",
            url: "/LoginNRegist/SendSMS",
            responseType: 'json',
            data: { scenecode: scene, phonenumber: phonenumber },
        }).then((response) => {
            if (response.status === 200 && response.data.result === true) { // 成功
                resolve({ result: response.data.result, scenecode: response.data.scenecode, msg: response.data.msg })
            } else { // 失败
                reject(response.data.msg)
            }
        }).catch((err) => {
            reject(err.message || "网络错误")
        })
    })
}

// 发送邮件验证码
export const sendEmail = (scene: string, emailaddress: string): Promise<{ result: boolean, scenecode: string, msg: string }> => {
    return new Promise((resolve, reject) => {
        instance({
            method: "post",
            url: "/LoginNRegist/SendEmail",
            data: { scenecode: scene, emailaddress: emailaddress },
        }).then((response) => {
            if (response.status === 200 && response.data.result === true) { // 成功
                resolve({ result: response.data.result, scenecode: response.data.scenecode, msg: response.data.msg })
            } else { // 失败
                reject(response.data.msg)
            }
        }).catch((err) => {
            reject(err.message || "网络错误")
        })
    })

}

// 获取微信登录二维码
export const getQRCode = (scene: string): Promise<{ base64Image: string, scenecode: string, ifWxScaned: boolean, error: string }> => {
    return new Promise((resolve, reject) => {
        instance({
            method: "get",
            url: "/LoginNRegist/GetQrCode",
            params: { scenecode: scene },
        }).then((response) => {
            if (response.status === 200 && response.data.result === true) { // 成功
                resolve({ base64Image: response.data.Base64Image, scenecode: response.data.SceneCode, ifWxScaned: response.data.ifWxScaned, error: response.data.msg })
            } else { // 失败
                reject({ base64Image: "", scenecode: scene, error: response.data.msg || "获取二维码失败" })
            }
        }).catch((err) => {
            reject({ base64Image: "", scenecode: scene, error: err.message || "网络错误" })
        })
    })
}

// 注册用户
export const registUser = (reqinfo: object): Promise<{ result: boolean, msg: string, jwttoken: string, refreshtoken: string }> => {
    return new Promise((resolve, reject) => {
        instance({
            method: "post",
            url: "/LoginNRegist/RegistUser",
            data: reqinfo,
        }).then((response) => {
            console.log(response.data);
            if (response.status === 200 && response.data.result === true) { // 成功
                resolve({ result: response.data.result, msg: response.data.msg, jwttoken: response.data.jwttoken, refreshtoken: response.data.refreshtoken })
            } else { // 失败
                reject(response.data.msg)
            }
        }).catch((err) => {
            reject(err.message || "网络错误")
        })

    })
}

// 登录验证
export const checklogin = (loginfo: object): Promise<{ result: boolean, msg: string, jwttoken: string, refreshtoken: string }> => {
    return new Promise((resolve, reject) => {
        instance({
            method: "post",
            url: "/LoginNRegist/CheckLogin",
            data: loginfo,
        }).then((response) => {
            if (response.status === 200 && response.data.result === true) {
                resolve({ result: response.data.result, msg: response.data.msg, jwttoken: response.data.jwttoken, refreshtoken: response.data.refreshtoken })
            } else {
                reject(response.data.msg)
            }
        }).catch((err) => {
            reject(err.message || "网络错误")
        })
    })
}

export const CheckState= (scenecode: string): Promise<{ result: boolean, msg?: string, data?: any, userinfo?: any }> => {
    return new Promise((resolve, reject) => {
        instance({
            method: "post",
            url: "/WeiXin/CheckState",
            data: { scene: scenecode },
        }).then((response) => {
            console.log(response.data);
            if (response.status === 200 && response.data.result === true) {
                resolve({ result: response.data.result, msg: response.data?.msg, data: response.data?.Data, userinfo: response.data?.userinfo })
            } else {
                reject(response.data.msg)
            }
        }).catch((err) => {            
            reject(err.message || "网络错误")
        })
    })
}

// 手机或邮箱登录验证登录
export const loginverify = (loginfo: object): Promise<{ result: boolean, msg: string, jwttoken: string, refreshtoken: string }> => {
    return new Promise((resolve, reject) => {
        instance({
            method: "post",
            url: "/LoginNRegist/LoginVerify",
            data: loginfo
        }).then((response) => {
            console.log(response)
            if (response.status === 200 && response.data.result === true) {
                resolve({ result: response.data.result, msg: response.data.msg, jwttoken: response.data.jwttoken, refreshtoken: response.data.refreshtoken })
            } else {
                reject(response.data.msg)
            }
        }).catch((err) => { reject(err.message || "网络错误") })
    })
}

// 修改用户信息申请场景码
export const modifyuserreqscene = (): Promise<{ result: boolean, msg: string, scenecode: string }> => {
    return new Promise((resolve, reject) => {
        instance({
            method: "get",
            url: "/LoginNRegist/ModifyUserReqScene",
        }).then((response) => {
            if (response.status === 200 && response.data.result === true) {
                resolve({ result: response.data.result, msg: response.data.msg, scenecode: response.data.data.scenecode })
            } else {
                reject(response.data.msg)
            }
        }).catch((err) => {
            reject(err.message || "网络错误")
        })
    })
}

// 修改用户名
export const changeusername = (changeuserinfo: object): Promise<{ result: boolean, msg: string }> => {
    return new Promise((resolve, reject) => {
        instance({
            method: "post",
            url: "/LoginNRegist/ChangeUserName",
            data: changeuserinfo
        }).then((response) => {
            if (response.status === 200 && response.data.result === true) {
                resolve({ result: response.data.result, msg: response.data.msg })
            } else {
                reject(response.data.msg)
            }
        }).catch((err) => {
            reject(err.message || "网络错误")
        })
    })
}

// 修改昵称
export const changenickname = (changeuserinfo: object): Promise<{ result: boolean, msg: string }> => {
    return new Promise((resolve, reject) => {
        instance({
            method: "post",
            url: "/LoginNRegist/ChangeNickName",
            data: changeuserinfo
        }).then((response) => {
            if (response.status === 200 && response.data.result === true) {
                resolve({ result: response.data.result, msg: response.data.msg })
            } else {
                reject(response.data.msg)
            }
        }).catch((err) => {
            reject(err.message || "网络错误")
        })
    })
}

// 修改手机号
export const changeuserphone = (changeuserinfo: object): Promise<{ result: boolean, msg: string }> => {
    return new Promise((resolve, reject) => {
        instance({
            method: "post",
            url: "/LoginNRegist/ChangeUserPhone",
            data: changeuserinfo
        }).then((response) => {
            if (response.status === 200 && response.data.result === true) {
                resolve({ result: response.data.result, msg: response.data.msg })
            } else {
                reject(response.data.msg)
            }
        }).catch((err) => {
            reject(err.message || "网络错误")
        })
    })
}

export const changeuseremail = (changeuserinfo: object): Promise<{ result: boolean, msg: string }> => {
    return new Promise((resolve, reject) => {
        instance({
            method: "post",
            url: "/LoginNRegist/ChangeUserMail",
            data: changeuserinfo
        }).then((response) => {
            if (response.status === 200 && response.data.result === true) {
                resolve({ result: response.data.result, msg: response.data.msg })
            } else {
                reject(response.data.msg)
            }
        }).catch((err) => {
            reject(err.message || "网络错误")
        })
    })
}

// 刷新token
export const refreshtoken = async (): Promise<{ result: boolean, msg: string, jwttoken: string }> => {

    return new Promise((resolve, reject) => {
        refreshinstance({
            method: "get",
            url: "/LoginNRegist/RefreshToken",
        }).then((response) => {
            if (response.status === 200 && response.data.result === true) {
                resolve({ result: response.data.result, msg: response.data.msg, jwttoken: response.data.jwttoken })
            } else {
                localStorage.removeItem("jwtToken");
                localStorage.removeItem("refreshToken");
                reject(response.data.msg)
            }
        }).catch((err) => {
            localStorage.removeItem("jwtToken");
            localStorage.removeItem("refreshToken");
            reject(err.message || "网络错误")
        })
    })
}


// 重置密码
export const resetpassword = (password: string): Promise<{ result: boolean, msg: string, jwttoken: string }> => {
    return new Promise((resolve, reject) => {
        instance({
            method: "post",
            url: "/LoginNRegist/ResetPassword",
            data: password,
        }).then((response) => {
            console.log(response)
            if (response.status === 200 && response.data.result === true) {
                resolve({ result: response.data.result, msg: response.data.msg, jwttoken: response.data.jwttoken })
            } else {
                reject(response.data.msg)
            }
        }).catch((err) => { reject(err.message || "网络错误") })
    })
}

// SignalR 用户消息服务
export const userSignalR = () => {
    let retryCount = 0;
    const maxRetryCount = 5;

    const startConnection = async () => {
        try {
            await connection.start();
            console.log("SignalR 连接已启动");
            retryCount = 0;
        } catch (err) {
            console.error("SignalR 连接启动失败: ", err);
            if (retryCount < maxRetryCount) {
                retryCount++;
                setTimeout(startConnection, 5000); // 5秒后重试连接
            }
        }

    }

    const stopConnection = async () => {
        try {
            await connection.stop();
            console.log("SignalR 连接已停止");
        } catch (err) {
            console.error("SignalR 连接停止失败: ", err);
        }
    }

    const onRegistered = (callback: any) => {
        connection.on("GetMsgConnectionId", callback);

    }


    const onReceiveMessage = async (callback: any) => {
        connection.on("ReceiveMessage", callback);
    }

    const RegistUserConnection = async (userid: string, connectionId: string) => {
        try {
            await connection.send("RegistUserConnection", userid, connectionId);
            console.log("用户连接注册成功");
        } catch (err) {
            console.error("用户连接注册失败: ", err);
        }
    }

    return { startConnection, stopConnection, onRegistered, onReceiveMessage, RegistUserConnection };
}
export { instance }; // 导出带jwttoken的axios实例
instance